import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Link } from 'react-router';
import logo from '../../../../public/catch-logo.png';

import * as actionCreators from '../../../actions/auth';
import RecoverForm from './RecoverForm';

class RecoverLogin extends React.Component {
  static propTypes = {
    statusText: PropTypes.string,
    actions: PropTypes.shape({
      authRecoverLogin: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      query: PropTypes.object.isRequired,
    }),
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(values) {
    if (values) {
      this.props.actions.authRecoverLogin(values.email);
    }
  }

  render() {
    let statusText = null;
    if (this.props.statusText) {
      const statusTextClassNames = classNames({
        alert: true,
        'alert-danger': this.props.statusText.indexOf('Error') === 0,
        'alert-success': this.props.statusText.indexOf('Error') !== 0,
      });

      statusText = (
        <div className="row">
          <div className="col-sm-12">
            <div className={statusTextClassNames}>{this.props.statusText}</div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="center-block-inner">
          <img className="" src={logo} alt="Catch" />
        </div>
        <div style={{ padding: '60px 60px 60px 60px' }}>
          <h4 className="text-left">Welcome to group travel simplified</h4>
          <h4 className="text-left">Recover Login</h4>
          <br />
          <div className="login-container margin-top-medium">
            {statusText}
            <RecoverForm onSubmit={this.handleSubmit} />
            <p className="center-text primary">
              <Link to="/login">Sign in?</Link>
            </p>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  statusText: state.auth.statusText,
});
const mapDispatchToProps = dispatch => ({
  dispatch,
  actions: bindActionCreators(actionCreators, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(RecoverLogin);



// WEBPACK FOOTER //
// src/routes/login/containers/RecoverLogin.js